<template>
  <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.63813 6.52417C1.43496 5.30511 2.37504 4.19537 3.61092 4.19537H24.3436C25.5795 4.19537 26.5196 5.30511 26.3164 6.52417L22.9358 26.8078C22.903 27.0045 22.841 27.196 22.7116 27.3476C22.1679 27.984 20.1549 29.6499 13.9773 29.6499C7.79961 29.6499 5.78662 27.9841 5.24299 27.3476C5.1135 27.196 5.05152 27.0045 5.01874 26.8078L1.63813 6.52417Z"
    />
    <path
      d="M26.7045 5.46808C26.7045 7.57681 21.0064 9.28627 13.9773 9.28627C6.94819 9.28627 1.25 7.57681 1.25 5.46808C1.25 3.35936 6.94819 1.6499 13.9773 1.6499C21.0064 1.6499 26.7045 3.35936 26.7045 5.46808Z"
    />
    <path
      d="M26.7045 5.46808C26.7045 7.57681 21.0064 9.28627 13.9773 9.28627C6.94819 9.28627 1.25 7.57681 1.25 5.46808C1.25 3.35936 6.94819 1.6499 13.9773 1.6499C21.0064 1.6499 26.7045 3.35936 26.7045 5.46808Z"
      stroke="#021B27"
      stroke-width="1.5"
    />
    <rect
      x="17.2803"
      y="13.7895"
      width="2.95041"
      height="11.8017"
      rx="0.5"
      transform="rotate(45 17.2803 13.7895)"
      fill="#021B27"
    />
    <rect
      x="8.93555"
      y="15.8759"
      width="2.95041"
      height="11.8017"
      rx="0.5"
      transform="rotate(-45 8.93555 15.8759)"
      fill="#021B27"
    />
  </svg>
</template>
